export const CAREGIVER_FETCH_REQUEST = 'CAREGIVER_FCH_REQUEST';
export const CAREGIVER_FETCH_SUCCESS = 'CAREGIVER_FETCH_SUCCESS';
export const CAREGIVER_FETCH_FAILURE = 'CAREGIVER_FETCH_FAILURE';

export const CAREGIVER_UPDATE_STATUS_REQUEST = 'CAREGIVER_UPDATE_STATUS_REQUEST';
export const CAREGIVER_UPDATE_STATUS_SUCCESS = 'CAREGIVER_UPDATE_STATUS_SUCCESS';
export const CAREGIVER_UPDATE_STATUS_FAILURE = 'CAREGIVER_UPDATE_STATUS_FAILURE';

export const CAREGIVER_ADD_FEEDBACK_REQUEST = 'CAREGIVER_ADD_FEEDBACK_REQUEST';
export const CAREGIVER_ADD_FEEDBACK_SUCCESS = 'CAREGIVER_ADD_FEEDBACK_SUCCESS';
export const CAREGIVER_ADD_FEEDBACK_FAILURE = 'CAREGIVER_ADD_FEEDBACK_FAILURE';

export const CAREGIVER_FETCH_FEEDBACK_REQUEST = 'CAREGIVER_FETCH_FEEDBACK_REQUEST';
export const CAREGIVER_FETCH_FEEDBACK_SUCCESS = 'CAREGIVER_FETCH_FEEDBACK_SUCCESS';
export const CAREGIVER_FETCH_FEEDBACK_FAILURE = 'CAREGIVER_FETCH_FEEDBACK_FAILURE';


 